import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { secretManager } from 'services/api/config';

const SALES_EMAIL = secretManager.salesEmail;

const GetInTouchButton = () => {
  const { t } = useTranslation();

  return (
    <Button
      variant="outlined"
      href={`mailto:${SALES_EMAIL}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Typography fontWeight={700}>
        {t('distribution:licenseBlock:getInTouch')}
      </Typography>
    </Button>
  );
};

export default GetInTouchButton;
